<template>
    <div class="item-table">
        <div class="item-table-description">{{ item.description }}</div>
        <CancellationTable :rows="rows" />
    </div>
</template>

<script lang="ts">
    import { defineComponent, computed, PropType } from 'vue';
    import { BookingCancellationItem } from './BookingCancellation.interfaces';
    import { CancellationTableRow } from '@ui/components/CancellationTable/CancellationTable.interfaces';
    import { convertToDate } from '@shared/helpers/datetime/datetime';
    import { t } from '@shared/helpers/translation';
    import { getLocaleDayShortMonthTime } from '@shared/helpers/datetime/datetime.formatters';
    import CancellationTable from '@ui/components/CancellationTable/CancellationTable.vue';

    export default defineComponent({
        name: 'BookingCancellation',
        methods: { t },
        components: {
            CancellationTable,
        },
        props: {
            item: {
                type: Object as PropType<BookingCancellationItem>,
                required: true,
            },
        },
        setup({ item }) {
            const rows = computed<CancellationTableRow[]>(() =>
                item.policies.map((x) => {
                    const label = `${t({ key: 'shared.after' })} ${getLocaleDayShortMonthTime(convertToDate(x.fromDate))}`;

                    return {
                        label,
                        cost: x.amount,
                        active: x.active,
                        refundable: x.refundable,
                    };
                })
            );

            return {
                rows,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward '../Cancellation.scss';
</style>
